<!-- @format -->

<div class="container-fluid ms-3 pe-3 me-2">
  <div class="row">
    <div class="col-12">
      <div class="mt-4">
        <h2 class="modal-title" tabindex="0">
          {{ module.name | localizedString }} ({{ module.targetCredits | creditRange }})
          <sis-non-active-document-state-badge [documentState]="module.documentState"></sis-non-active-document-state-badge>
        </h2>
      </div>
      <div class="mb-3">
        <span>{{ module.code }} | {{ moduleLocalizationKey | translate }}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-4 col-md-6 col-sm-12 order-first">
      <sis-version-selector
        [currentVersionId]="module.id"
        [options]="options"
        (change)="changeVersion($event)"
        [popoverInfoKey]="popoverInfoLocalizationKey"
        [popoverLabelKey]="popoverLabelLocalizationKey"
        [popoverPlacement]="'right'">
      </sis-version-selector>
    </div>
    <div class="col-lg-12 order-lg-2 order-md-1">
      @if (versionChanged) {
        <sis-version-switch-notification
          [versionSwitchAllowed]="canUseCurrentVersion"
          [versionCompatibleTranslationKey]="versionCompatibleLocalizationKey"
          [versionNotCompatibleTranslationKey]="versionNotCompatibleLocalizationKey"
          [switchVersionTranslationKey]="switchVersionLocalizationKey"
          (saveVersionChange)="saveVersionChange.emit()">
        </sis-version-switch-notification>
      }
    </div>
    <div class="col-lg-6 ms-xl-5 ps-xl-5 order-lg-1 order-md-2">
      <sis-description-list-compact [columnCount]="1">
        <dl>
          <ng-template #compactListItem>
            <dt class="label colon">{{ "FIELD_NAMES.attainment" | translate }}</dt>
            @if (attainment) {
              <dd class="value">
                {{ attainment.state | attainmentStatusTranslation | translate }}
                @if (attainment.credits) {
                  <span>({{ attainment.credits | decimalNumber }} {{ "CREDITS" | translate }})</span>
                }
              </dd>
            } @else {
              <dd class="value">
                {{ "MODULE_INFO.NOT_ATTAINED" | translate }}
              </dd>
            }
          </ng-template>
          <ng-template #compactListItem>
            <dt class="label colon">{{ "FIELD_NAMES.grade" | translate }}</dt>
            @if (attainment) {
              <dd class="value">
                {{ attainment.gradeId | grade: attainment.gradeScaleId : "NAME" | async }}
              </dd>
            } @else {
              <dd class="value">
                {{ "MODULE_INFO.NOT_GRADED" | translate }}
              </dd>
            }
          </ng-template>
        </dl>
      </sis-description-list-compact>
    </div>
  </div>
</div>
